import type { Session } from './types'

export type ScheduleStats = {
  totalWithRewards: number
  completedCount: number
  totalPoints: number
  totalCoins: number
  percent: number
}

/**
 * Computa estatísticas de progresso do participante na programação.
 * Apenas sessões com `has_rewards` são contabilizadas — sessões sem
 * recompensa (intervalos, etc.) não entram na barra de progresso.
 */
export const computeScheduleStats = (sessions: Session[]): ScheduleStats => {
  let totalWithRewards = 0
  let completedCount = 0
  let totalPoints = 0
  let totalCoins = 0

  for (const session of sessions) {
    if (!session.has_rewards) continue

    totalWithRewards++

    if (session.finished) {
      completedCount++
      totalPoints += session.point_reward ?? 0
      totalCoins += session.coin_reward ?? 0
    }
  }

  const percent = totalWithRewards > 0
    ? Math.round((completedCount / totalWithRewards) * 100)
    : 0

  return { totalWithRewards, completedCount, totalPoints, totalCoins, percent }
}
